window.notificationNS = {

    notification: function (id, type, data) {

        var url = null;
        var success_message = null;
        var error_message = "Falha no envio de notificação. Por favor contactar suporte@kentratech.com ";

        var params = {id: id, data: data};

        switch (type){
            case globalConstants.EXTERNAL_NOTIFICATION_APPOINTMENT:
                url = "/appointments/notification";
                success_message = "Notificação de agendamento de episódio enviada.";
                break;

            case globalConstants.EXTERNAL_NOTIFICATION_INVOICE_CREATED:
                url = "/billing/notification";
                success_message = "Fatura enviada eletronicamente para o utente";
                break;

            case globalConstants.EXTERNAL_NOTIFICATION_RSP_PRESCRIPTION_CREATED:
                url = "/prescription/external_medication/notification";
                success_message = "Guia de tratamento enviada eletronicamente para o utente";
                break;

            case globalConstants.EXTERNAL_NOTIFICATION_ANALYSIS_PRESCRIPTION_CREATED:
                url = "/analysis/notification";
                success_message = "Requisição de análises enviada eletronicamente para o utente";
                break;

            case globalConstants.EXTERNAL_NOTIFICATION_MCDT_PRESCRIPTION_CREATED:
                url = "/exam/notification";
                success_message = "Requisição de exame enviada eletronicamente para o utente";
                break;
        }

        $.ajax({
            url: url,
            dataType: "json",
            type: 'POST',
            data: params,

            success: function (data,st, xhr) {

                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.flg_notification == true){
                    if (data.data == null) {
                        Hades.showBalloonMessage(error_message, 'alert-error', 10000);
                    }
                    else if (data.data.resultStatus == 1){
                        Hades.showBalloonMessage(success_message, 'alert-success', 5000);
                        Hades.hideLoading();
                    }
                    else
                    {
                        Hades.showBalloonMessage(error_message, 'alert-error', 10000);
                    }
                }

            },
            error: function (data,st, xhr) {
                Hades.showBalloonMessage(error_message, 'alert-error', 10000);
                Hades.hideLoading();
            }
        });

    }
}